var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegetarian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.2 58.2",
    style: {
      enableBackground: "new 0 0 58.2 58.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3C1412;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "vegetarian",
    className: "st0",
    d: "M29.1,0C13,0,0,13,0,29.1c0,16,13,29.1,29.1,29.1c16,0,29.1-13,29.1-29.1 C58.2,13,45.1,0,29.1,0z M32.3,55.1c3.4-9.4,5.4-21.6-4-33.7c9.9,10.5,10.4,18.9,8.9,27.6c6.2-3.2,10.3-12.2,7.9-19.7 C41.7,18.5,29.8,8.5,11.2,12.7C22.5,18.5,15,31,17.3,39.3c2.2,7.8,7.3,11.1,12.8,11.3c-0.6,1.6-1.3,3.2-2,4.7 c-14-0.5-25.3-12.1-25.3-26.2c0-14.5,11.8-26.2,26.2-26.2c14.5,0,26.2,11.8,26.2,26.2C55.3,42.5,45.3,53.5,32.3,55.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetarian);
export default __webpack_public_path__ + "static/media/vegetarian.75af8366f874143601a4f50d30a56811.svg";
export { ForwardRef as ReactComponent };